<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
        <el-tab-pane label="入口成绩计算设置" name="0"></el-tab-pane>
        <el-tab-pane label="均量值计算设置" name="1"></el-tab-pane>
        <el-tab-pane label="阶段入口占比设置" name="2"></el-tab-pane>
        <el-tab-pane label="中考入口占比设置" name="3"></el-tab-pane>
        <el-tab-pane label="强/弱科计算设置" name="4"></el-tab-pane>
        <el-tab-pane label="教师等级计算设置" name="5"></el-tab-pane>
        <el-tab-pane label="图表展示次数设置" name="6"></el-tab-pane>
        <el-tab-pane label="指标占比设置" name="7"></el-tab-pane>
        <el-tab-pane label="指标设定" name="8"></el-tab-pane>
        <el-tab-pane label="标注管理" name="9"></el-tab-pane>
      </el-tabs>
    </div>
    <entry-list ref="entryList" v-if="active==0">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="onCreate('entryDialog')" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows('entryList','ConfigEntryId')">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="70"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="onEditById('entryDialog',row.ConfigEntryId)">编辑</el-button>
        </template>
      </el-table-column>
    </entry-list>
    <average-list ref="averageList" v-else-if="active==1">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="onCreate('averageDialog')" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows('averageList','MeanValueId')">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="70"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="onEditById('averageDialog',row.MeanValueId)">编辑</el-button>
        </template>
      </el-table-column>
    </average-list>
    <stage-list ref="stageList" v-else-if="active==2">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="onCreate('stageDialog')" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows('stageList','ConfigLvId')">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="70"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="onEditById('stageDialog',row.ConfigLvId)">编辑</el-button>
        </template>
      </el-table-column>
    </stage-list>
    <zk-list ref="zkList" v-else-if="active==3">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="onCreate('zkDialog')" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows('zkList','ConfigLvId')">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="70"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="onEditById('zkDialog',row.ConfigLvId)">编辑</el-button>
        </template>
      </el-table-column>
    </zk-list>
    <update-subject v-else-if="active=='4'" ref="updateSubject" />
    <teacher-lv v-else-if="active=='5'" ref="teacherLv" />
    <show-count v-else-if="active=='6'" ref="showCount" />
    <update-index v-else-if="active=='7'" ref="updateIndex" />
    <zb-list ref="zblist" v-else-if="active=='8'">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="mini" plain class="filter-item" type="primary" @click="zbExport">导出</el-button>
        <el-button size="mini" plain class="filter-item" type="success" @click="zbImport">导入</el-button>
      </template>
    </zb-list>
    <bz-list ref="bzList" v-else-if="active=='9'">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="onCreate('bzDialog')" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows('bzList','MarkId')">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        :width="isMB?'60':'100'"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="onEditById('bzDialog',row.MarkId)">编辑</el-button>
        </template>
      </el-table-column>
    </bz-list>
    <entry-dialog ref="entryDialog" @close-saved="reload('entryList')"></entry-dialog>
    <average-dialog ref="averageDialog" @close-saved="reload('averageList')"></average-dialog>
    <stage-dialog ref="stageDialog" @close-saved="reload('stageList')"></stage-dialog>
    <zk-dialog ref="zkDialog" @close-saved="reload('zkList')"></zk-dialog>
    <bz-dialog ref="bzDialog" @close-saved="reload('bzList')"></bz-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import entryList from "@/components/achieve/params/entryList";
import entryDialog from "@/components/achieve/params/entryDialog";
import averageList from "@/components/achieve/params/averageList";
import averageDialog from "@/components/achieve/params/averageDialog";
import stageList from "@/components/achieve/params/stageList";
import stageDialog from "@/components/achieve/params/stageDialog";
import zkList from "@/components/achieve/params/zkList";
import zkDialog from "@/components/achieve/params/zkDialog";
import teacherLv from "@/components/achieve/params/teacherLv";
import updateSubject from "@/components/achieve/params/updateSubject";
import showCount from "@/components/achieve/params/showCount";
import updateIndex from "@/components/achieve/params/updateIndex";
import zbList from "@/components/achieve/params/zblist";
import bzList from "@/components/analyse/mark/list";
import bzDialog from "@/components/analyse/mark/editDialog";
 
export default {
  name: "user",
  mixins: [curdMixins],
  components: {
    entryList,
    entryDialog,
    averageList,
    averageDialog,
    stageList,
    stageDialog,
    zkList,
    zkDialog,
    teacherLv,
    updateSubject,
    showCount,
    updateIndex,
    zbList,
    bzList,
    bzDialog
  },
  data() {
    return {
      active: "0",
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    reload(name) {
      if(!name) {
        name = 'entryList'
      }
      this.$refs[name].getData();
    },
    onCreate(name) {
      this.$refs[name].openCreate();
    },
    onEditById(name,id) {
      this.$refs[name].openEditById(id);
    },
    zbImport() {
      this.$refs.zblist.import();
    },
    zbExport() {
      this.$refs.zblist.export();
    },
    handleClick(e) {
      setTimeout(() => {
        switch (e.name) {
          case "0":
            this.reload('entryList');
          break;
          case "1":
            this.reload('averageList');
          break;
          case "2":
            this.reload('stageList');
          break;
          case "3":
            this.reload('zkList');
          break;
          case "4":
            this.reload('updateSubject');
          break;
          case "5":
            this.reload('teacherLv');
          break;
          case "6":
            this.reload('showCount');
          break;
          case "7":
            this.reload('updateIndex');
          case "9":
            this.reload('bzList');
          break;
        }
      }, 30);
    },
    delRows(name,id) {
      let rows = this.$refs[name].getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item[id];
          });
          this.$refs[name].delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>